export default __webpack_public_path__ + "static/media/previous.f666eddb.svg";